import { useFeatureFlagVariantKey, useFeatureFlagPayload } from "posthog-js/react";
import { FEATURE_FLAGS } from "./feature-flags";
import { useEffect } from "react";
import posthog from "posthog-js";
import { usePostHogState } from "../_providers/posthog";

export function useLoadingFeatureFlagEnabled(
  flag: FEATURE_FLAGS,
  { variantKey, forceEnabled }: { forceEnabled?: boolean; variantKey?: boolean | string } = {},
) {
  const featureFlagsLoaded = usePostHogState(state => state.featureFlagsLoaded);
  const flagVariant = useFeatureFlagVariantKey(flag);
  const payload = useFeatureFlagPayload(flag);

  useEffect(() => {
    posthog.capture("$feature_flag_called", {
      $feature_flag: flag,
      $feature_flag_response: flagVariant,
    });
  }, [flagVariant, flag]);

  if (forceEnabled)
    return {
      enabled: true,
      isPending: false,
      payload,
    };

  return {
    enabled: flagVariant === variantKey || flagVariant === true,
    isPending: !featureFlagsLoaded,
    payload,
  };
}
